import * as React from 'react';

import type {Integration} from '../../integrations/integrations-page-content/types';
import {StackLegacy} from '../../layout/stack/stack-legacy';
import {Body} from '../../typography/body';

import {IntegrationsForm} from '../integrations-form/integrations-form';

import {IntegrationBulletedList} from './integration-bulleted-list';

import styles from './individual-integration-page.module.css';

type Props = {
    integration: Integration;
    submitIntegrationsForm: (
        integrationId: string,
        email: string,
        username: string,
        password: string,
        requestedActions: string[]
    ) => void;
};

export function IndividualIntegrationPage(props: Props) {
    return (
        <div className='pad-16'>
            <StackLegacy spacing={32}>
                <StackLegacy spacing={0}>
                    <img
                        src={props.integration.integrationBannerUrl}
                        alt='logo'
                        className={styles.image}
                    />
                    <Body color='light' isItalic={true}>
                        {props.integration.primaryText}
                    </Body>
                    <div className='mt-32'>
                        <Body isBold={true} size='large'>
                            This is a marketplace integration which will be activated in 5-7
                            business days after we have all the required information.
                        </Body>
                    </div>
                    {props.integration.integrationActionItems && (
                        <IntegrationBulletedList
                            heading='What does this integration do?'
                            items={props.integration.integrationActionItems}
                        />
                    )}
                    {props.integration.supportedFields && (
                        <IntegrationBulletedList
                            heading='Fields that connect:'
                            items={props.integration.supportedFields}
                        />
                    )}
                    {props.integration.noteFromNutshellTeam && (
                        <IntegrationBulletedList
                            heading='A note from the Nutshell team:'
                            items={props.integration.noteFromNutshellTeam}
                        />
                    )}
                    {props.integration.requirements && (
                        <IntegrationBulletedList
                            heading='Requirements:'
                            items={props.integration.requirements}
                        />
                    )}
                </StackLegacy>
                <StackLegacy spacing={8}>
                    <Body isBold={true} size='large'>
                        Get started with {props.integration.name}:
                    </Body>
                    <IntegrationsForm
                        integrationId={props.integration.integrationId}
                        appName={props.integration.name}
                        // @ts-expect-error
                        checkboxValues={props.integration.integrationActionItems || []}
                        submitIntegrationsForm={props.submitIntegrationsForm}
                    />
                </StackLegacy>
            </StackLegacy>
        </div>
    );
}
